import type { Dispatch, SetStateAction } from "react";

export function patch<T>(setter: Dispatch<SetStateAction<T>>) {
  return <K extends keyof T>(key: K, value: T[K]) =>
    setter((prev) => ({ ...prev, [key]: value }));
}
